import { render, staticRenderFns } from "./next.vue?vue&type=template&id=1dcd5df6&scoped=true&"
import script from "./next.vue?vue&type=script&lang=js&"
export * from "./next.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/next.scss?vue&type=style&index=0&id=1dcd5df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcd5df6",
  null
  
)

export default component.exports